import React, {Component} from 'react';
import '../assets/golf-course.css'
import {withNamespaces} from 'react-i18next';
import LazyImage from '../components/lazy-image';
import Pagination from '@material-ui/lab/Pagination';
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import httpRequest from '../components/request-api'
import Rating from '@material-ui/lab/Rating';

class GolfCourse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            count: 0,
            golfCourseData: [],
            searchKey: "",
            preload: false
        }
    }

    componentDidMount() {
        this.fetchDataCouse(1, "")
    }

    fetchDataCouse = async (page, search) => {
        this.setState({
            preload: true
        })
        await httpRequest.fetchCouse(search, page).then(result => {
            this.setState({
                golfCourseData: result.data.result.data,
                count: result.data.result.totalPage,
                page: page,
                preload: false
            })
        }).catch(error => {
            console.log(error);
            this.setState({
                preload: false
            })
        })
    }

    handleClick = (course_code) => {
        this.props.history.push(`/golf-course-detail/${course_code}/${localStorage.getItem("i18nextLng")}`)
    };

    golfCourseCard() {
        const setName = (item) => {
            if (this.props.lng === "th") {
                return `${item.name_th !== "-" ? item.name_th : item.name_en}`
            } else if (this.props.lng === "en") {
                return `${item.name_en !== "-" ? item.name_en : item.name_th}`
            }
        };

        const data = this.state.golfCourseData.map((item, index) => {
            return (
                <div className="col-lg-4 col-md-6 col-sm-6" key={index}>
                    <div className="single-cat text-center mb-50 cursor" onClick={() => this.handleClick(item.course_code)} style={{left: "1px"}}>
                        <div className="cat-icon">
                            {
                                item['teeoff_measure'] ? <img src="assets/img/check.png" className="golf-course-check"/> : null
                            }

                            <LazyImage
                                thumb={`${item['course_photo'] !== false ? `data:image/png;base64,${item['course_photo']}` : '/assets/img/default-empty-golf-field.jpg'}`}
                                main={`${item['course_photo'] !== false ? `data:image/png;base64,${item['course_photo']}` : '/assets/img/default-empty-golf-field.jpg'}`}

                                alt="woman leaning against monitor displaying Pacman game"
                                height={570 / 1260}
                            />
                        </div>
                        <div className="cat-cap text-left pt-3 pl-2">
                            <p className="blue-color mb-0">{setName(item)}</p>
                            <div className='d-flex'>
                                <Rating name="half-rating" value={item['satisfaction_score']} precision={0.5} readOnly/>
                                <span className="secondary-color ml-1">{item['satisfaction_score']} ({item['satisfaction_count']} {item['satisfaction_count'] > 1 ? 'reviews' : 'review'})</span>
                            </div>
                        </div>
                    </div>
                </div>
            )
        })
        return data
    }

    handleChange = (event, page) => {
        this.fetchDataCouse(page, this.state.searchKey)
    };

    handleSearchContact = (e) => {
        let {value} = e.target
        this.setState({
            searchKey: value,
        })
    };

    Search() {
        const {searchKey} = this.state
        this.fetchDataCouse(1, searchKey)
    }

    searchInput() {
        const {t} = this.props;
        return (
            <FormControl fullWidth variant="outlined" className="search">
                <div className="row j-center">
                    <OutlinedInput className="col-xl-8 col-lg-6"
                                   id="outlined-adornment-amount"
                                   placeholder={t('search')}
                                   startAdornment={<InputAdornment position="start"> <i
                                       className="ti-search"/></InputAdornment>}
                                   value={this.state.searchKey}
                                   onChange={e => this.handleSearchContact(e)}
                    />
                    <Button variant="contained" color="primary" className="col-xl-2 col-lg-4"
                            onClick={e => this.Search()}>
                        {t('enter')}
                    </Button>
                </div>
            </FormControl>
        )
    }

    render() {
        const {t} = this.props;
        const {page, count, preload} = this.state

        return (
            <div>
                <section>
                    <div className="container" style={{"marginBottom": "7rem"}}>
                        <div className="row">
                            <h3 className="blue-color text-left col" style={{alignSelf: "center"}}>{t('golfCourse')}</h3>
                            <div className="col">{this.searchInput()} </div>
                        </div>
                        <div className="row" style={{margin: 0}}>
                            <div className="mr-3">
                                <img src="assets/img/check.png" style={{width: '35px', marginTop: '4px'}}/>
                            </div>
                            <div className="text-left">
                                <span>{t('symbol')}</span>
                                <p>{t('courseRatedDesc')}</p>
                            </div>
                        </div>
                        {this.state.golfCourseData.length === 0 && !preload ?
                            <h6 className="p-5">Course not found. Please try again !</h6> :
                            <div>
                                {preload ?
                                    <div id="preloader-active">
                                        <div className="preloader d-flex align-items-center justify-content-center"
                                             style={{backgroundColor: "initial"}}>
                                            <div className="preloader-inner position-relative">
                                                <div className="preloader-circle"></div>
                                                <div className="preloader-img pere-text">
                                                    <img src="/assets/img/logo/TGALogo.png" alt=""/>
                                                </div>
                                            </div>
                                        </div>
                                    </div> :
                                    <div>
                                        <div className="row">
                                            {this.golfCourseCard()}
                                        </div>
                                        <Pagination count={count} page={page} size="large" onChange={this.handleChange} className="justify-content-center"/>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </section>
            </div>
        );
    }
}

export default withNamespaces()(GolfCourse);